import { render, staticRenderFns } from "./research.vue?vue&type=template&id=101fe868"
import script from "./research.vue?vue&type=script&lang=ts"
export * from "./research.vue?vue&type=script&lang=ts"
import style0 from "./research.vue?vue&type=style&index=0&id=101fe868&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports